import MainLayoutVue from '@/generic/layouts/MainLayout.vue';
import SurveyFinishVue from './views/SurveyFinish.vue';
import SurveyClosedVue from './views/SurveyClosed.vue';
import SurveyStartVue from './views/SurveyStart.vue';
import SurveyViewWrapperVue from './views/SurveyViewWrapper.vue';

export default [
    {
        path: '/:knowledgeModelAlias?/survey',
        component: MainLayoutVue,
        children: [
            {
                path: ':arg?',
                component: SurveyViewWrapperVue,
                name: 'survey',
            },
            // {
            //     path: 'combined',
            //     name: 'survey-combined',
            //     component: SurveyViewCombinedVue,
            // },
            {
                path: 'start',
                name: 'survey-start',
                component: SurveyStartVue,
            },
            {
                path: 'finish',
                name: 'survey-finish',
                component: SurveyFinishVue,
            },
            {
                path: 'closed',
                name: 'survey-closed',
                component: SurveyClosedVue,
            },
        ],
    },
];
